<template>
  <div class="card-loader">
    <span class="card-loader__machine"></span>
    <CreditCard
      :card="card"
      :isFlipped="isFlipped"
      :class="{
        'creditcard--animated': isAnimated,
        'creditcard--endstate': isEndState || !animation,
      }"
    />
  </div>
</template>

<script>
import { CreditCard } from '@/components/payment';

export default {
  name: 'CreditCardLoader',
  components: {
    CreditCard
  },
  props: {
    card: {
      cardNumber: String,
      expirationDate: String,
      holder: String,
      securityCode: String,
      brand: String,
      disableAnimation: Boolean,
    },
    animation: {
      type: Boolean,
      default: true,
    }
  },
  data: () => ({
    isFlipped: false,
    isAnimated: false,
    isEndState: false,
  }),
  created() {
    if (this.animation) {
      this.startCreditCardPresentation();
    }
  },

  methods: {
    startCreditCardPresentation() {
      setTimeout(() => {
        this.isAnimated = true;
      }, 1000);

      setTimeout(() => {
        this.isEndState = true;
      }, 3500);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-loader {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 350px;
  justify-content: flex-start;
  overflow: hidden;
  position: relative;
  top: 30px;
  width: 100%;

  &__machine {
    background-color: var(--color-grey-5);
    border-radius: 90px 90px 0 0;
    height: 8px;
    position: relative;
    width: 206px;
    z-index: 1;
  }

  & .creditcard {
    position: absolute;
    top: 100px;
    transform: scale(0.85);
    z-index: 0;

    &--animated {
      animation: insert-card 3.5s;
    }

    &--endstate {
      top: -66px;
      transform: rotate(90deg) scale(0.85);
    }
  }
}

@keyframes insert-card {

  0% {
    transform: rotate(0deg) scale(0.85);
  }

  43.99% {
   transform: rotate(89deg) scale(0.85);
  }

  49% {
    transform: rotate(90deg) scale(0.85);
  }

  50% {
    top: 100px;
    transform: rotate(90deg) scale(0.85);
  }

  90% {
    top: -50px;
    transform: rotate(90deg) scale(0.85);
  }

  100% {
    top: -66px;
    transform: rotate(90deg) scale(0.85);
  }
}
</style>
